import { useState } from 'react';

const WHATSAPP_NUMBER = '5563992058487';
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=Ol%C3%A1!%20Gostaria%20de%20saber%20mais%20sobre%20o%20SipDash%20%F0%9F%8D%B9`;

export default function WhatsAppButton() {
  const [hovered, setHovered] = useState(false);
  const [tooltipDismissed, setTooltipDismissed] = useState(false);

  return (
    <div className="fixed bottom-6 left-6 z-50 flex items-center gap-3">
      {/* Tooltip bubble */}
      {(hovered && !tooltipDismissed) && (
        <div className="bg-white rounded-2xl px-4 py-3 max-w-[180px] animate-fade-in"
          style={{ boxShadow: '0 4px 24px rgba(0,0,0,0.10)' }}>
          <button
            onClick={(e) => { e.stopPropagation(); setTooltipDismissed(true); }}
            className="absolute top-2 right-2 w-4 h-4 flex items-center justify-center text-gray-300 hover:text-gray-500 cursor-pointer"
          >
            <i className="ri-close-line text-xs" />
          </button>
          <p className="text-xs font-bold text-gray-800 leading-snug">Need help?</p>
          <p className="text-xs text-gray-500 mt-0.5 leading-snug">Chat with us on WhatsApp!</p>
        </div>
      )}

      {/* Main button */}
      <div className="relative">
        {/* Pulse ring */}
        <span className="absolute inset-0 rounded-full animate-ping opacity-30"
          style={{ backgroundColor: '#25D366' }} />
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="nofollow noreferrer"
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
          className="relative w-14 h-14 flex items-center justify-center rounded-full text-white transition-transform hover:scale-110 cursor-pointer"
          style={{ backgroundColor: '#25D366', boxShadow: '0 4px 20px rgba(37,211,102,0.45)' }}
          aria-label="Chat on WhatsApp"
        >
          <i className="ri-whatsapp-line text-2xl" />
        </a>
      </div>
    </div>
  );
}
